module.exports = __webpack_public_path__ + "img/the-red-queen.0ac62450.png";